import "./card.css"
import {FiGithub} from 'react-icons/fi';
import { IconContext } from "react-icons";

const card = ({title, description, githubLink, tech}) => {
  return (
    <div className="card-container">

    
    <div className="card">
      <div className="card__details">
        <div className="icons-card">
            <IconContext.Provider value={{className: "react-icons react-icons-card", size: "1.5rem"}}>
                <a href={githubLink} target="_blank" rel="noopener noreferrer"><FiGithub /></a>
            </IconContext.Provider>
        </div>
        <div className="card-title">
            {title}
        </div>
        <p className="tech-txt">{tech}</p>        
        <p>{description}</p>
      </div>
    </div>
  </div>
  )
}

export default card